var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8214 6.80296C16.8214 9.45555 14.6628 11.6059 12 11.6059C9.3372 11.6059 7.17857 9.45555 7.17857 6.80296C7.17857 4.15036 9.3372 2 12 2C14.6628 2 16.8214 4.15036 16.8214 6.80296ZM20 18.2053C20 22 12 22 12 22C12 22 4 21.8737 4 18.2053C4 14.5369 7.58172 13 12 13C16.4183 13 20 14.4107 20 18.2053Z",
    fill: "#9CA0A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6b62a67d4afc12ad2f98332def9581c1.svg";
export { ForwardRef as ReactComponent };